"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("../icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Put an icon next to some text.
 *
 * The icon and text will be vertically centered, with standard spacing between.
 */
class IconText extends _react.default.Component {
  renderIcon(icon) {
    if (typeof icon === 'string') {
      return /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: icon
      });
    }

    return icon;
  }

  render() {
    const {
      props
    } = this;
    const flexrule = props.inline ? 'inline-flex' : 'flex';
    const before = !props.iconBefore ? null : /*#__PURE__*/_react.default.createElement("span", {
      className: "mr6"
    }, this.renderIcon(props.iconBefore));
    const after = !props.iconAfter ? null : /*#__PURE__*/_react.default.createElement("span", {
      className: "ml6"
    }, this.renderIcon(props.iconAfter));
    return /*#__PURE__*/_react.default.createElement("span", {
      className: `${flexrule} flex--center-cross`
    }, before, /*#__PURE__*/_react.default.createElement("span", null, props.children), after);
  }

}

IconText.propTypes = {
  /**
   * The text. A string is recommended, but you can put an element in here if
   * you think it's right. If you do, it should be inline-level,
   * using `<span>`s instead of `<div>`s.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * The size of the gap between the text and the icon: `"small"` or `"large"`.
   */
  gap: _propTypes.default.oneOf(['small', 'large']),

  /**
   * An icon to place before the text. If the value is a string, it should name an
   * Assembly icon. If you bring your own SVG or want finer-grained control over
   * how the Icon component is used, pass an element.
   */
  iconBefore: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),

  /**
   * An icon to place after the text. See details documented for `iconBefore`.
   */
  iconAfter: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),

  /**
   * A boolean indicating whether the component's wrapper element should be
   * 'flex' (false) or 'inline-flex' (true).
   */
  inline: _propTypes.default.bool
};
IconText.defaultProps = {
  gap: 'small',
  inline: false
};
var _default = IconText;
exports.default = _default;